const initialState = {
  optoutStatus: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_OPTED_STATUS':
      return {
        ...state,
        optoutStatus: action.data,
      }
    default:
      return state
  }
}
